import i18n from "i18next";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { AddShopOrdersToBatchDataGridApi_ShopOrderDto } from "src/api/generated/erp/production/shopOrderBatch/api/addShopOrdersToBatchDataGridApi.ts";
import { useState } from "react";
import { getOnlyMember } from "src/utils/arrayUtils.ts";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import { ObjectMainDocumentApi } from "src/api/generated/documents/api/objectMainDocumentApi.ts";
import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { FileHandlePreviewView } from "src/components/views/documents/preview/FileHandlePreviewView.tsx";
import {
	AddShopOrdersToBatchDataGrid,
	AddShopOrdersToBatchDataGridProps,
} from "src/components/views/erp/production/shopOrderBatch/AddShopOrdersToBatchDataGrid.tsx";
import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";

export const AddShopOrdersToBatchView = ({
	onSelectionChanged: onSelectionChangedProp,
	...other
}: AddShopOrdersToBatchDataGridProps) => {
	const tenantCustomizations = useTenantCustomizations();

	const [selectedRows, setSelectedRows] = useState<AddShopOrdersToBatchDataGridApi_ShopOrderDto[]>([]);
	const onlySelectedRow = getOnlyMember(selectedRows);

	const showDocumentView =
		tenantCustomizations.erp?.production?.addShopOrdersToBatchView?.showCatalogPartRevisionMainDocument ?? false;

	const dataGrid = (
		<AddShopOrdersToBatchDataGrid
			onSelectionChanged={(selectedRows) => {
				setSelectedRows(selectedRows);
				onSelectionChangedProp?.(selectedRows);
			}}
			{...other}
		/>
	);

	if (!showDocumentView) return dataGrid;

	return (
		<AavoMosaic
			viewId={"addShopOrdersToBatchView"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("shop_orders"),
					content: dataGrid,
				},
				second: {
					type: "panel",
					title: i18n.t("document"),
					content:
						onlySelectedRow == null ?
							<CenteredTypography>{i18n.t("select_shop_order")}</CenteredTypography>
						:	<RevisionMainDocumentView key={onlySelectedRow.shopOrderId} shopOrder={onlySelectedRow} />,
				},
			}}
		/>
	);
};

const RevisionMainDocumentView = ({ shopOrder }: { shopOrder: AddShopOrdersToBatchDataGridApi_ShopOrderDto }) => {
	return (
		<AsyncFetchRender
			fetch={() =>
				ObjectMainDocumentApi.getObjectMainDocument({
					objectRef: {
						objectType: "CATALOG_PART_REVISION",
						objectId: shopOrder.catalogPartRevisionId,
					},
				})
			}
			content={(fileHandle) => {
				if (fileHandle == null) return <CenteredTypography>{i18n.t("no_document")}</CenteredTypography>;

				return <FileHandlePreviewView fileHandle={fileHandle} />;
			}}
		/>
	);
};
